export default __webpack_public_path__ + "static/media/kitten.8390add0.png";